// extracted by mini-css-extract-plugin
export default {"container":"Table-module__container__ul8m+","table":"Table-module__table__irGAu"};